import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {HttpTokenInterceptor} from './interceptors';
import {StoreModule} from '@ngrx/store';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {EffectsModule} from '@ngrx/effects';
import {environment} from '../../environments/environment';
import {effects, reducers} from './store';
import {LangStorageService} from './services';
import {AppConfigService} from './services/app-config.service';
import {FeaturesService} from './services/features.service';
import {NgxMaskModule} from 'ngx-mask';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    HttpClientModule,
    StoreModule.forRoot(reducers),
    environment.production ? [] : StoreDevtoolsModule.instrument({ maxAge: 50 }),
    EffectsModule.forRoot(effects),
    NgxMaskModule.forRoot(),
  ],
  exports: [
    HttpClientModule,
    StoreModule,
    EffectsModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: HttpTokenInterceptor, multi: true},
    LangStorageService,
    AppConfigService,
    FeaturesService
  ]
})
export class CoreModule { }
